import { render, staticRenderFns } from "./ProconAverageComplaintsSixMonths.container.vue?vue&type=template&id=7c62321e&"
import script from "./ProconAverageComplaintsSixMonths.container.vue?vue&type=script&lang=ts&"
export * from "./ProconAverageComplaintsSixMonths.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports